import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sidebar", "backdrop"];

  toggle() {
    const sidebar = this.sidebarTarget;
    const backdrop = this.backdropTarget;
    
    sidebar.classList.toggle("-translate-x-full");
    backdrop.classList.toggle("hidden");
    
    // Prevent body scroll when sidebar is open
    if (sidebar.classList.contains("-translate-x-full")) {
      document.body.classList.remove("modal-scroll-locked");
    } else {
      document.body.classList.add("modal-scroll-locked");
    }
  }

  close() {
    const sidebar = this.sidebarTarget;
    const backdrop = this.backdropTarget;
    
    sidebar.classList.add("-translate-x-full");
    backdrop.classList.add("hidden");
    document.body.classList.remove("modal-scroll-locked");
  }

  connect() {
    // Close sidebar when clicking on a link (mobile only)
    const links = this.sidebarTarget.querySelectorAll("a");
    links.forEach((link) => {
      link.addEventListener("click", () => {
        // Only close on mobile (below sm breakpoint)
        if (window.innerWidth < 640) {
          this.close();
        }
      });
    });

    // Handle window resize - ensure sidebar is closed on desktop
    this.handleResize = () => {
      if (window.innerWidth >= 640) {
        // On desktop, ensure sidebar is visible (remove translate)
        this.sidebarTarget.classList.remove("-translate-x-full");
        this.backdropTarget.classList.add("hidden");
        document.body.classList.remove("modal-scroll-locked");
      }
    };
    window.addEventListener("resize", this.handleResize);
  }

  disconnect() {
    if (this.handleResize) {
      window.removeEventListener("resize", this.handleResize);
    }
  }
}
